import { render, staticRenderFns } from "./AdsForm.vue?vue&type=template&id=6d297e37&"
import script from "./AdsForm.vue?vue&type=script&lang=js&"
export * from "./AdsForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports